<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup Customer
 * @created at      :   2024/07/16
 * @created by      :   Hainn – HaiNN@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import store from '@/store';
import { mapState, mapActions, mapMutations } from 'vuex';
import popupCustomer from '@/views/popupSearch/popup_customer/store';
/**
 * Define component for popup
 */
import helpers from '@/utils/helpers';

var Customer = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('popupCustomer')) {
            store.registerModule('popupCustomer', popupCustomer);
        }
    },
    created() {
        this.onInitScreen();
        // if (this.initData) {
        //     this.department_cd = this.initData;
        // } else {
        //     this.department_cd = '';
        // }
        this.onSearchItem();
    },
    // data() {
    //     return {
    //         department_cd: ''
    //     };
    // },
    mounted() {
        const btnClose = document.querySelector('.btn-close');
        if (btnClose) {
            btnClose.addEventListener('click', this.clearCustomerCd);
        }
        window.addEventListener('keydown', this.handleEscKey);
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('popupCustomer', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('popupCustomer', ['searchCustomerInfo']),
        ...mapMutations('popupCustomer', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            // this.data.department_cd = this.department_cd;
            this.searchCustomerInfo(this.data);
        },
        changeCurrentPage(data) {
            // this.data.department_cd = this.department_cd;
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchCustomerInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseCustomer(data) {
            this.$emit('onReferModelValue', data.customer_cd);
            this.$emit('onReferValueName', data.customer_name);
            this.$emit('close');
            this.data.customer_cd = '';
            this.data.customer_name = '';
        },
        clearCustomerCd() {
            this.data.customer_cd = '';
            this.data.customer_name = '';
        },
        handleEscKey(event) {
            if (event.key === 'Escape' || event.keyCode === 27) {
                this.data.customer_cd = '';
                this.data.customer_name = '';
            }
        }
    }
};
export default Customer;
</script>

<style lang="scss">
@import '@/assets/scss/common/popup.scss';
</style>
